import '../styles/About.scss';


const About = () => {
  return (
    <div className="about">
            <div className='text'>
          <h1>About Us</h1>
          <p>Established in 1949, Metal Distributors has over 75 years of experience in the lead industry. We pride ourselves on producing high-quality products and sourcing our raw materials from reputable suppliers.</p>
          <p>All our products are now locally manufactured in Abbotsford, BC, by our team of skilled technicians.</p>
        </div>
        <img className='robot' src='https://user-images.githubusercontent.com/77664153/185462150-c89b5ca0-150f-401f-833d-d9201def1c99.jpg' alt='robot made from anodes' />
      </div>
    // </div>
  );
};

export default About;